import ContratsTab from "@features/rh/contrats/components/ContratsTab";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { FileText } from "lucide-react";

export const Route = createFileRoute("/_app/rh/contrats/")({
  loader: requirePermission(PERMISSIONS.RH.CONTRATS.VIEW),
  staticData: {
    title: "Contrats",
    icon: FileText,
    tab_icon: FileText,
    permission: PERMISSIONS.RH.CONTRATS.VIEW,
    module: "rh",
    section: "Ressources Humaines",
    order: 23,
    showInNav: true,
    showInTab: true,
    showInBreadcrumb: true,
    description: "Gestion des Contrats",
  },
  component: ContratsTab,
});
